import * as React from 'react';
import ChangeSummary from './images/change-summary.png';
import ChangeSummarySp from './images/change-summary-sp.png';
import './topSection.module.scss';
import { observer } from 'mobx-react';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { MobBr } from '../../../../commonv3/components/atoms/layouts/br';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../../routes';

export const CtaBox = ({ mobile }) => (
    <div styleName="cta-box">
        <div styleName="cta-text">
            2チケットで1ヶ月分が無料に<br />
            移行期限：10/31まで
        </div>
        <Button
            styleName="cta-button"
            type="primary"
            size="l"
            onClick={() => GlobalStatesV3.routing.push(V3Routes.application())}
        >
            {mobile ? '無料で移行する' : '無料で新しいSHElikesに移行する'}
        </Button>
    </div>
);

export const TopSection = observer(() => {
    const mobile = GlobalStatesV3.viewport.isMobile;
    return (
        <div styleName="section">
            <div styleName="header">
                9/1に正式リリース！<MobBr />SHELikesは大幅にパワーアップ致します!
            </div>
            <div styleName="text">
                これまで会員の皆様には、1チケット1レッスンのチケット制でSHElikesのレッスンを受講頂いておりましたが、
                頂いたご意見を解決するために以下のように変化します。<br />
                <b>11月から新プランに"完全移行"となりますので、会員の皆様は10/31までに移行手続きをお願いします。</b>
            </div>
            <img styleName="change-summary" src={mobile ? ChangeSummarySp : ChangeSummary} />
            <CtaBox mobile={mobile} />
        </div>
    );
});
